import {
  CheckBoxOutlineBlankRounded,
  CheckBoxRounded,
} from "@mui/icons-material";
import { createTheme } from "@mui/material";

export const Theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1200,
      xl: 1920,
    },
  },
  components: {
    MuiInputBase: {
      styleOverrides: {
        root: {
          height: "48px",
          alignContent: "center",
        },
        sizeSmall: {
          height: "36px",
        },
        input: {
          // padding: "12.5px 14px !important",
        },
        inputMultiline: {
          padding: "0 !important",
        },
        multiline: {
          height: "auto",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          paddingInline: "6px",
          paddingBlock: "6px",
          minHeight: "40px",
          fontSize: "14px",
          fontWeight: 400,
          minWidth: "unset",

          "&.Mui-selected": {
            fontWeight: 500,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: "40px",
          // paddingInline: "8px",
          "& .MuiTabs-flexContainer": {
            gap: "10px",
          },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: "20px",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: "#263141",
          p: "6px 8px",
        },
        arrow: {
          color: "#263141",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "10px",
          height: "36px",
          minWidth: "80px",
          padding: 0,
          margin: 0,
        },
        sizeSmall: {
          padding: "6px 16px",
          minWidth: "10px",
        },
        sizeMedium: {
          paddingBlock: "6px",
          paddingInline: "12px",
        },
        sizeLarge: {
          padding: "11px 24px",
        },
        textSizeSmall: {
          padding: "7px 12px",
        },
        textSizeMedium: {
          padding: "9px 12px",
        },
        textSizeLarge: {
          padding: "12px 16px",
        },
        textGray: {
          backgroundColor: "rgba(0, 0, 0, 0.03)",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.07)",
          },
        },
        outlinedGray2: {
          borderColor: "#BCC7DB",
          backgroundColor: "#F5F8FC",
          "&:hover": {
            borderColor: "#bcbcbc !important",
          },
        },
        outlinedGray: {
          borderColor: "#E6EEF7 ",
          backgroundColor: "#F5F8FC",
          "&:hover": {
            borderColor: "#bcbcbc !important",
          },
        },
      },
      variants: [
        {
          props: {
            color: "white",
            variant: "contained",
          },
          style: {
            backgroundColor: "#FFFFFF",
            color: "#111C2B",
            border: "1px solid #BCC7DB",
            "&:hover": {
              backgroundColor: "#F2F2F2",
              color: "#111C2B",
            },
          },
        },
      ],
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          padding: "0 6px",
          gap: "8px",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.16)",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          lineHeight: "21px",
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: "32px 24px",
          "&:last-child": {
            paddingBottom: "32px",
          },
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: {
          variant: "h6",
        },
        subheaderTypographyProps: {
          variant: "body2",
        },
      },
      styleOverrides: {
        root: {
          padding: "32px 24px",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          boxSizing: "border-box",
          margin: 0,
          padding: 0,
        },
        html: {
          MozOsxFontSmoothing: "grayscale",
          WebkitFontSmoothing: "antialiased",
          display: "flex",
          flexDirection: "column",
          minHeight: "100%",
          width: "100%",
        },
        body: {
          display: "flex",
          flex: "1 1 auto",
          flexDirection: "column",
          minHeight: "100%",
          width: "100%",
        },
        "#__next": {
          display: "flex",
          flex: "1 1 auto",
          flexDirection: "column",
          height: "100%",
          width: "100%",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: "#E6E8F0",
        },
        input: {
          "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
            webkitAppearance: "none",
          },
          "&[type=number]": {
            MozAppearance: "textfield",
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: `0 !important`,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: {
          backgroundColor: "#10B9811F !important",
          "& .MuiChip-label": {
            color: "#0B815A",
            fontWeight: 600,
          },
        },
        filledGray: {
          backgroundColor: "#0000001F !important",
          "& .MuiChip-label": {
            color: "#808080",
            fontWeight: 600,
          },
        },
        warningFilled: {
          backgroundColor: "#FFB0201F !important",
          "& .MuiChip-label": {
            color: "#B27B16",
            fontWeight: 600,
          },
        },
        outlinedGray: {
          borderColor: "#C4CFE4 !important",
          backgroundColor: "#F7FAFC",
          "& .MuiChip-label": {
            color: "#3D4758",
            fontWeight: 600,
            fontSize: "12px",
          },
        },
        deletable: {
          "& .MuiChip-label": {
            marginRight: "auto",
          },
        },
      },
      variants: [
        {
          props: { variant: "more" },
          style: {
            border: "1px solid #C4CFE4",
            backgroundColor: "transparent",
            "& .MuiChip-label": {
              color: "#1760D2",
              fontWeight: 500,
              fontSize: "12px",
            },
          },
        },
        {
          props: { variant: "outlined", color: "info" },
          style: {
            border: "1px solid #C4CFE4",
            backgroundColor: "transparent",
            "& .MuiChip-label": {
              color: "#1760D2",
              fontWeight: 500,
              fontSize: "12px",
            },
          },
        },
        {
          props: { variant: "generated" },
          style: {
            backgroundColor: "#06AED41F",
            "& .MuiChip-label": {
              color: "#0E7090",
              fontWeight: 600,
              fontSize: "12px",
            },
          },
        },
        {
          props: { variant: "draft" },
          style: {
            backgroundColor: "#06AED41F !important",
            "& .MuiChip-label": {
              color: "#0E7090",
              fontWeight: 600,
            },
          },
        },
        {
          props: { variant: "stockTakeDraft" },
          style: {
            backgroundColor: "#0000001F !important",
            "& .MuiChip-label": {
              color: "#808080",
              fontWeight: 600,
              fontSize: "12px",
            },
          },
        },
      ],
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& .MuiTableCell-root": {
            fontSize: "12px",
            lineHeight: "100%",
            padding: "10px 8px",
            border: "none",
            color: "#111C2B",
            fontWeight: 600,
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: "40px",
        },
        head: {
          height: "34px",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: "8px",
          borderBottom: "1px solid #DFE8F2",
          fontSize: "14px",
          fontWeight: 400,

          // "&:last-child": {
          //   paddingRight: "8px",
          // },

          // ":first-of-type": {
          //   paddingLeft: "8px",
          // },
        },
      },
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: {
          margin: "0 4px",
          fontSize: "12px",
          lineHeight: "16px",
        },
      },
    },
    MuiAutocomplete: {
      variants: [
        {
          props: {
            variant: "filter",
            size: "small",
          },
          style: {
            "& .MuiOutlinedInput-root": {
              fontSize: "14px",
              backgroundColor: "#E7F0FF",
              color: "#1760D2",
              // placeholder color
              "& .MuiInputBase-input::placeholder": {
                color: "#0000005C",
                opacity: 1,
                fontWeight: 400,
              },
              fontWeight: 500,
              "& fieldset": {
                borderColor: "#7DADF6",
              },
              "&:hover fieldset": {
                borderColor: "#7DADF6",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#7DADF6",
              },
            },
          },
        },
      ],
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: "10px",
          height: "32px",
          paddingBlock: "8px",
          gap: "8px",
          margin: "8px",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          "& .MuiMenu-list": {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "44px",
          overflow: "hidden", // Prevent content from overflowing
          "& .MuiToolbar-root": {
            minHeight: "40px",
            padding: 0,
            flexWrap: "wrap", // Optional: allow wrapping if content exceeds
          },
        },
        select: {
          padding: "5px 24px 4px 8px !important",
          minWidth: "unset", // Prevent default min-width from causing overflow
        },
        toolbar: {
          justifyContent: "center",
          padding: 0,
          overflow: "hidden",
          "& .MuiTablePagination-toolbar": {
            height: "40px",
            padding: 0,
            overflow: "hidden",
            flexWrap: "wrap", // Allow wrapping if necessary
          },
        },
        displayedRows: {
          marginRight: "8px",
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        icon: <CheckBoxOutlineBlankRounded />, // unchecked state
        checkedIcon: <CheckBoxRounded />, // checked state
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: "#5E7360",
          color: "#FFFFFF",
        },
      },
    },
  },
  palette: {
    neutral: {
      10: "#111C2B",
      20: "#263141",
      35: "#485364",
      63: "#8E99AC",
      80: "#BCC7DB",
      90: "#DFE8F2",
      95: "#E6EEF7",
      98: "#F7FAFC",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
    },
    action: {
      active: "#6B7280",
      focus: "rgba(55, 65, 81, 0.12)",
      hover: "rgba(55, 65, 81, 0.04)",
      selected: "rgba(55, 65, 81, 0.08)",
      disabledBackground: "rgba(55, 65, 81, 0.12)",
      disabled: "rgba(55, 65, 81, 0.26)",
    },
    background: {
      default: "#F5F8FC",
      paper: "#FFFFFF",
    },
    divider: "#DFE8F2",
    primary: {
      main: "#0B57D0",
      light: "#3b78d9",
      dark: "#073c91",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#10B981",
      light: "#3FC79A",
      dark: "#0B815A",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#14B8A6",
      light: "#43C6B7",
      dark: "#0E8074",
      contrastText: "#FFFFFF",
    },
    info: {
      main: "#1560D4",
      light: "#64B6F7",
      dark: "#0B79D0",
      contrastText: "#FFFFFF",
    },
    gray: {
      main: "#111C2B",
      light: "#64B6F7",
      dark: "#0B79D0",
      contrastText: "#FFFFFF",
    },
    gray2: {
      main: "#485364",
      light: "#64B6F7",
      dark: "#cccccc",
      contrastText: "#000000",
    },
    warning: {
      main: "#FFB020",
      light: "#FFBF4C",
      dark: "#B27B16",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#C60808",
      light: "#DA6868",
      dark: "#922E2E",
      contrastText: "#FFFFFF",
    },
    errorChip: {
      main: "#F044381F",
      light: "#F044381F",
      dark: "#922E2E",
      contrastText: "#B42318",
    },
    text: {
      primary: "#111C2B",
      secondary: "#657083",
      disabled: "rgba(55, 65, 81, 0.48)",
    },
    white: {
      main: "#FFFFFF",
      dark: "#E6EEF7",
      contrastText: "#111C2B",
    },
  },
  shape: {
    borderRadius: 8,
  },
  shadows: [
    "none",
    "0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)",
    "0px 1px 2px rgba(100, 116, 139, 0.12)",
    "0px 1px 4px rgba(100, 116, 139, 0.12)",
    "0px 1px 5px rgba(100, 116, 139, 0.12)",
    "0px 1px 6px rgba(100, 116, 139, 0.12)",
    "0px 2px 6px rgba(100, 116, 139, 0.12)",
    "0px 3px 6px rgba(100, 116, 139, 0.12)",
    "0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)",
    "0px 5px 12px rgba(100, 116, 139, 0.12)",
    "0px 5px 14px rgba(100, 116, 139, 0.12)",
    "0px 5px 15px rgba(100, 116, 139, 0.12)",
    "0px 6px 15px rgba(100, 116, 139, 0.12)",
    "0px 7px 15px rgba(100, 116, 139, 0.12)",
    "0px 8px 15px rgba(100, 116, 139, 0.12)",
    "0px 9px 15px rgba(100, 116, 139, 0.12)",
    "0px 10px 15px rgba(100, 116, 139, 0.12)",
    "0px 12px 22px -8px rgba(100, 116, 139, 0.25)",
    "0px 13px 22px -8px rgba(100, 116, 139, 0.25)",
    "0px 14px 24px -8px rgba(100, 116, 139, 0.25)",
    "0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
    "0px 25px 50px rgba(100, 116, 139, 0.25)",
  ],
  typography: {
    button: {
      fontWeight: 600,
    },
    fontFamily:
      '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
    body1: {
      fontSize: "1rem",
      fontWeight: 400,
      lineHeight: 1.5,
    },
    body2: {
      fontSize: "0.813rem",
      fontWeight: 400,
      lineHeight: "0.983rem",
    },
    subtitle1: {
      fontSize: "1rem",
      fontWeight: 500,
      lineHeight: 1.75,
    },
    subtitle2: {
      fontSize: "0.875rem",
      fontWeight: 400,
      lineHeight: "17px",
    },

    overline: {
      fontSize: "0.75rem",
      fontWeight: 600,
      letterSpacing: "0.5px",
      lineHeight: 2.5,
      textTransform: "uppercase",
    },
    caption: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: 1.66,
    },
    h1: {
      fontWeight: 700,
      fontSize: "3.5rem",
      lineHeight: 1.375,
    },
    h2: {
      fontWeight: 700,
      fontSize: "3rem",
      lineHeight: 1.375,
    },
    h3: {
      fontWeight: 700,
      fontSize: "2.25rem",
      lineHeight: 1.375,
    },
    h4: {
      fontWeight: 700,
      fontSize: "2rem",
      lineHeight: 1.375,
    },
    h5: {
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: 1.375,
    },
    h6: {
      fontWeight: 600,
      fontSize: "1.125rem",
      lineHeight: 1.375,
    },
  },
});
